export { default } from './UpdateEmailModal.component';
